import * as React from 'react';
import { render } from 'react-dom';

import './legacy/serp.css';

import { onDOMReady } from '../../utils/ready';
import {
  bootstrapBSCAddRequest,
  bootstrapBSCSerpItemDOM,
  bootstrapBSCSerpMetrics,
  ISerpItem,
} from './utils/bootstrap_serp_dom';

import { trackingSerpShowNotFound } from './tracking';

import FilterContainer, { IFilterContainerProps } from './components/filters/container';
import MarkedList, { IMarkedListProps } from './components/marked_list/marked_list';
import SerpViewToggleContainer from './components/serp_view_toggle/container';
import { TSerpMapToggleTab } from './components/serp_view_toggle/serp_view_toggle';

import NotFoundSubscription, {
  INotFoundSubscriptionProps,
} from './components/not_found_subscription/not_found_subscription';

interface IBSCSerpBundle {
  bootstrapBSCSerpItemDOM: typeof bootstrapBSCSerpItemDOM;
  bootstrapBSCSerpMetrics: typeof bootstrapBSCSerpMetrics;
  FilterContainer: typeof FilterContainer;
  NotFoundSubscription: typeof NotFoundSubscription;
  MountMapSearch: () => void;
  SerpViewToggleContainer: typeof SerpViewToggleContainer;
  MarkedList: typeof MarkedList;
}

function loadBundle(): Promise<IBSCSerpBundle> {
  return new Promise((resolve, reject) => (
    require.ensure([
      './utils/bootstrap_serp_dom',
      './components/filters/container',
      './components/map_search/loader',
      './components/marked_list/marked_list',
    ], () => {
      const {
        bootstrapBSCSerpItemDOM,
        bootstrapBSCSerpMetrics,
      } = require('./utils/bootstrap_serp_dom');

      resolve({
        bootstrapBSCSerpItemDOM,
        bootstrapBSCSerpMetrics,
        FilterContainer: require('./components/filters/container').default,
        MountMapSearch: require('./components/map_search/loader').default,
        NotFoundSubscription: require('./components/not_found_subscription/not_found_subscription').default,
        SerpViewToggleContainer: require('./components/serp_view_toggle/container').default,
        MarkedList: require('./components/marked_list/marked_list').default,
      } as IBSCSerpBundle);
    })
  ));
}

function renderBusinessShoppingCentersSerp(data: {[key: string]: ISerpItem} ) {
  onDOMReady(() => (
    loadBundle().then(({ bootstrapBSCSerpItemDOM, bootstrapBSCSerpMetrics }) => {
      const trackButton = document.querySelector('[data-track-change-conditions]') as HTMLElement | null;
      const serpItems = Array.from(document.querySelectorAll('[data-serp-item]') as NodeListOf<HTMLElement>);
      const addRequestBtn = document.querySelector('[data-add-request]') as HTMLElement | null;

      if (serpItems.length === 0) {
        return;
      }

      serpItems.forEach((node) => {
        const id = node.dataset['serpItemId'];
        if (data[id]) {
          bootstrapBSCSerpItemDOM(node, Number(id), data[id]);
        }
      });

      bootstrapBSCAddRequest(addRequestBtn);

      if (!trackButton) {
        return;
      }

      const listingType = trackButton.getAttribute('data-listing-type');
      if (listingType !== 'BC' && listingType !== 'TC' && listingType !== 'WC') {
        return;
      }

      bootstrapBSCSerpMetrics({
        changeConditionsButton: trackButton,
        trackingData: {
          listingType: listingType as 'BC' | 'TC' | 'WC',
        },
      });
    })
  ));
}

function renderBusinessShoppingCentersFilters(props: IFilterContainerProps) {
  onDOMReady(() => loadBundle().then(({ FilterContainer }) => {
    const filterRootNode = document.querySelector('[data-cf-bc-filters]');

    if (!filterRootNode) {
      return;
    }

    render(
      <FilterContainer {...props} />,
      filterRootNode
    );
  }));
}

function renderBusinessShoppingCentersMapSearch() {
  onDOMReady(() => loadBundle().then(({ MountMapSearch }) => MountMapSearch()));
}

function renderBusinessShoppingCentersSerpToggle() {
  onDOMReady(() => loadBundle().then(({ SerpViewToggleContainer }) => {
    const rootNodes = document.querySelectorAll('[data-cf-bc-serp-view-toggle]') as NodeListOf<HTMLElement>;
    const mapSearch = document.querySelector('[data-cf-bc-map-search]');

    if (!rootNodes || !rootNodes.length || !mapSearch) {
      return;
    }

    Array.prototype.forEach.call(rootNodes, (node: HTMLElement) => {
    render(
      <SerpViewToggleContainer containerType={node.dataset.cfBcSerpViewToggle as TSerpMapToggleTab} />,
      node
    );
    });
  }));
}

function renderBusinessShoppingCentersSerpNotFound(props: INotFoundSubscriptionProps) {
  onDOMReady(() => loadBundle().then(({ NotFoundSubscription }) => {
    const rootNode = document.querySelector('[data-not-found-subscription-root]');

    if (!rootNode) {
      return;
    }

    trackingSerpShowNotFound();

    render(
      <NotFoundSubscription {...props} />,
      rootNode
    );
  }));
}

function renderBusinessShoppingCentersMarkedList(props: IMarkedListProps) {
  onDOMReady(() => loadBundle().then(({ MarkedList }) => {
    const markedListRootNode = document.querySelector('[data-cf-bsc-marked-list]');

    if (!markedListRootNode) {
      return;
    }

    render(
      <MarkedList {...props} />,
      markedListRootNode
    );
  }));
}

function initBusinessShoppingCentersSerp() {
  /* tslint:disable:no-any */
  (window as any).renderBusinessShoppingCentersSerp = renderBusinessShoppingCentersSerp;
  (window as any).renderBusinessShoppingCentersFilters = renderBusinessShoppingCentersFilters;
  (window as any).renderBusinessShoppingCentersMapSearch = renderBusinessShoppingCentersMapSearch;
  (window as any).renderBusinessShoppingCentersSerpNotFound = renderBusinessShoppingCentersSerpNotFound;
  (window as any).renderBusinessShoppingCentersSerpToggle = renderBusinessShoppingCentersSerpToggle;
  (window as any).renderBusinessShoppingCentersMarkedList = renderBusinessShoppingCentersMarkedList;
  /* tslint:enable:no-any */
}

export default initBusinessShoppingCentersSerp;



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_centers_serp/index.tsx